// 清掉 localStorage 中被誤存成 "undefined"/壞掉 JSON 的欄位，避免讀取時整頁白屏
for (const key of ['user', 'tenant']) {
  try {
    const raw = localStorage.getItem(key)
    if (raw !== null) JSON.parse(raw)
  } catch {
    try { localStorage.removeItem(key) } catch { /* ignore */ }
  }
}
